import React from 'react';
import { Button, Flex, FlexProps, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { DownloadIcon, SearchIcon } from '@chakra-ui/icons';

interface Props extends Pick<FlexProps, 'mt'> {
  searchText: string;
  onSearchChange: (value: string) => void;
  onDownload: () => void;
}

export const StatisticActionBar: React.FC<Props> = ({ searchText, onSearchChange, onDownload, mt }) => {
  return (
    <Flex w="1040px" align="center" justify="space-between" mt={mt}>
      <InputGroup w="min(475px, 100%)">
        <InputLeftElement>
          <SearchIcon color="#00AAFF" />
        </InputLeftElement>
        <Input
          placeholder="搜尋機構名稱或證書名稱"
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          fontFamily="'Open Sans', sans-serif"
          fontSize="16px"
        />
      </InputGroup>
      <Button
        h="34px"
        px="16px"
        bg="#00AAFF"
        color="#FFFFFF"
        borderRadius="4px"
        fontFamily="'Open Sans', sans-serif"
        fontSize="16px"
        fontWeight={600}
        _hover={{ bg: '#0099E6' }}
        _active={{ bg: '#0088CC' }}
        onClick={onDownload}
      >
        <DownloadIcon boxSize="16px" mr="8px" />
        報表下載
      </Button>
    </Flex>
  );
};

export default StatisticActionBar;
